import React, { Component } from 'react';
import { SLoad, SText, STheme, SView } from 'servisofts-component2';

export default class PButtom extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        // var bgColor = this.props.primary ? STheme.color.secondary : this.props.primary ? STheme.color.info : STheme.color.primary;
        var bgColor = STheme.color.secondary;
        // var colorText = this.props.primary ? STheme.color.primary : this.props.secondary ? STheme.color.white : STheme.color.primary;

        var colorText = STheme.color.primary;
        if (this.props.withe) {
            bgColor = "#fff"
            colorText = STheme.color.primary;
        }
        var size = {
            width: this.props.width ?? 350,
            height: this.props.height ?? 55,
        }
        if (this.props.small) {
            size.width = 100;
            size.height = 30;
        }
        const borderRadius = this.props.borderRadius ?? 12;
        const fullWidth = this.props.fullWidth || this.props.width === "100%";
        return (<SView height={size.height} style={{
            borderRadius,
            width: "100%",
            maxWidth: fullWidth ? "100%" : size.width,
            ...(this.props.outline ? { borderWidth: 1, borderColor: bgColor } : { backgroundColor: bgColor }),
        }} center
            activeOpacity={this.props.loading ? 1 : 0.5}
            {...this.props}
            onPress={() => {
                if (this.props.loading) return;
                if (this.props.onPress) {
                    this.props.onPress();
                }
            }} >
            {this.props.loading ? <SLoad /> : <SText {...this.props} bold color={this.props.outline ? bgColor : colorText} >
                {/* {this.props.children} */}

            </SText>}
        </SView>);
    }
}
